import React, { useEffect, useState } from 'react';
import { HeaderBarStyle } from '../../styles';
import { useSelector } from 'react-redux';
import { Col, Row } from 'antd';
import { TextLarge } from '../../../text';
import { ROUTES_PATH } from '../../../../resources/routes-name';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const HeaderLayout = () => {
  const history = useHistory();
  const title = useSelector((state) => state.title.title);
  const profile = useSelector((state) => state.line.profile);
  let [date, setDate] = useState(new Date());

  function handleProfileClick() {
    const path = ROUTES_PATH.ROUTE_PROFILE.PATH;
    history.push(path);
  }

  useEffect(() => {
    var timer = setInterval(() => {
      setDate(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: '5px',
          left: '10px',
          color: 'black',
          fontSize: '7px',
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          padding: '2px 5px',
          borderRadius: '3px',
          zIndex: 1000,
        }}
      >
        {`${date.toLocaleDateString('th-TH', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        })} ${date.toLocaleTimeString('th-TH', {
          hour12: false,
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        })}`}
      </div>
      <HeaderBarStyle>
        <Row justify="space-between" align="middle">
          <Col span={3}>{/* วันที่และเวลาถูกย้ายไปที่ fixed position ด้านบน */}</Col>
          <Col span={18} style={{ textAlign: 'center' }}>
            <TextLarge
              text={title}
              style={{
                color: 'white',
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                display: 'block',
              }}
            />
          </Col>
          <Col span={3} style={{ textAlign: 'right', paddingRight: '10px' }}>
            {profile?.pictureUrl && (
              <img
                src={profile?.pictureUrl}
                alt="Profile"
                width="40"
                height="40"
                onClick={handleProfileClick}
                style={{ borderRadius: '50%', cursor: 'pointer' }}
              />
            )}
          </Col>
        </Row>
      </HeaderBarStyle>
    </>
  );
};

export default HeaderLayout;
